var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}}),_c('TabContent',{attrs:{"show-banner":"","selected-tab":_vm.selectedTab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }